export default "__VITE_ASSET__svCnzXLZ__"